export default __webpack_public_path__ + "3a1360cd1d572724bd2099f4d3f2f1de.jpg";